import React, { useMemo } from 'react'
import { FormattedDate, FormattedTime, useIntl } from 'react-intl'
import { selectUnit } from '@formatjs/intl-utils'
import Icon from 'components/Icon'

const Task = ({ timestamp, body, title, last, meta }) => {
  const { type = null, retake = false } = meta || {}

  return (
    <li>
      <div className="relative pb-8">
        { !last &&
          <span className={`absolute top-5 left-5 -ml-px h-full w-0.5 ${retake ? 'bg-yellow-400' : 'bg-gray-200'}`} aria-hidden="true"></span>
        }
        <div className="relative flex items-start space-x-3">
          <div>
            <div className="relative px-1 mx-3 mt-3">
              <div className={`h-2 w-2 rounded-full ring-4 ring-white ${retake ? 'bg-yellow-400' : 'bg-tertiary'}`} />
            </div>
          </div>
          <div className={`min-w-0 flex-1 py-0 rounded-sm border text-sm ${retake ? 'bg-yellow-50 border-yellow-400' : 'bg-green-50 border-positive'}`}>
            <div className="w-full flex items-center justify-between p-2">
              <div className="font-medium text-gray-600 space-x-2">
                <span>{ title }</span>
                <Icon icon="check" className={retake ? 'text-yellow-400' : 'text-green-400'} />
              </div>

              <div className="whitespace-nowrap text-gray-500 text-xs">
                <FormattedDate value={timestamp * 1000} /> <FormattedTime value={timestamp * 1000} />
              </div>
            </div>

            { body && body.length &&
              <div className="p-2 italic">
                { body }
              </div>
            }
          </div>
        </div>
      </div>
    </li>
  )
}

export default Task
